<template>
  <div class="app-container" style="padding: 40px; text-align: center;">
    <p>「特例车牌」已合并至「捷卫士车辆管理」，正在跳转…</p>
  </div>
</template>

<script>
export default {
  name: 'ChepaiDeprecated',
  created() {
    this.$router.replace({ path: '/chechang-wuye/jwsVehicleManage', query: this.$route.query })
  },
}
</script>
